import axios from "axios";

export class cancelRequestAxios {
  constructor() {
    this.cancel_resquest = null;
  }

  cancelAndCreateToken = () => {
    if (this.cancel_resquest) {
      this.cancel_resquest.cancel();
    }
    this.cancel_resquest = axios.CancelToken.source();
  };

  // reset Cancel token
  resetCancelToken = () => {
    this.cancel_resquest = null;
  };
}
